(function() {
    'use strict';

    angular
        .module('app')
        .directive('icheck', icheck);

    icheck.$inject = ['$window'];
    
    function icheck ($window) {
        // Usage:
        //     <icheck></icheck>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                check: '=',
                enable: '=?'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            $(element).iCheck({
                checkboxClass: 'icheckbox_square-blue',
                radioClass: 'iradio_square-blue',
                increaseArea: '20%' // optional
            });

            scope.$watch('scope.check', function (value) {
                if (value) {
                    $(element).iCheck('check');
                }
                else {
                    $(element).iCheck('uncheck');
                }
            });

            scope.$watch('scope.enable', function (value) {
                if (value == undefined) {
                    return;
                }
                if (value) {
                    $(element).iCheck('disable');
                }
                else {
                    $(element).iCheck('enable');
                }
            });


        }
    }

})();